/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../Context/MyProvider';
import axios from 'axios';
import { showToast } from '../showTost';
import Razorpay from './Razorpay';
import secureLocalStorage from 'react-secure-storage';
import Paypal from './Paypal';
import PayStack from './PayStack';
import FlutterWave from './FlutterWave';
import PayFast from './PayFast';
import Stripe from './Stripe';
import PaytmPayment from './Paytm';
import MercadoPago from './MercadoPago.jsx';
import Midtrans from './Midtrans.jsx';
import KhaltiPayment from './KhaltiPayment.jsx';
import { useTranslation } from 'react-i18next';

const Payment = ({ Index, Amount, Data }) => {

    const { t } = useTranslation();
    const { ApiBasUrl, ImgBasUrl, paymentloading, setPaymentLoading, setPaymentRes } = useContext(MyContext);

    const [paymentlist, setPaymentList] = useState([]);
    const [selectpayment, setSelectPayment] = useState("");
    const [input, setInput] = useState("");
    const [loading, setLoading] = useState(true);
    const [attributes, setAttributes] = useState();
    const [isbutton, setIsButton] = useState(false);

    useEffect(() => {
        axios.post(`${ApiBasUrl}/paymentgateway.php`)
            .then((res) => {
                // console.log(res.data.paymentdata);
                setPaymentList(res.data.paymentdata);
                setLoading(false);
            })
            .catch((error) => {
                console.error("paymentgateway.php", error);
            });
    }, []);

    const HandleContinue = () => {
        if (paymentloading) return;

        if (Index === 0 && !input) {
            showToast({ title: t("Please Enter Amount !!"), id: "error" });
            return;
        }

        if (!selectpayment) {
            showToast({ title: t("Select Payment Methode !!"), id: "error" });
            return;
        }

        secureLocalStorage.setItem("Paymentid", selectpayment);

        if (Index === 0) {
            secureLocalStorage.setItem("Amount", Amount);
        }
        sessionStorage.setItem("pages", Index);
        if (Data) {
            secureLocalStorage.setItem("bookingdata", JSON.stringify(Data));
        }

        if (Index === 1 && selectpayment === "16") {
            sessionStorage.setItem("transactionid", "0");
            setPaymentRes("PaymentDone");
            return;
        }

        setIsButton(true);
        setPaymentLoading(true);
    };

    return (
        <div>
            <div className="">
                <div className="">
                    {Index === 0 && <div className="">
                        <h1 className='font-[500] text-[17px] mb-[5px]'>{t("Add Wallet Amount")}</h1>
                        <div className="border-[2px] focus-within:border-[#682afb] rounded-[10px] px-[15px] py-[8px]">
                            <div className="flex items-center gap-[10px]">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.75 6.297V6C18.75 3.582 17.418 2.25 15 2.25H5C3.483 2.25 2.25 3.483 2.25 5V18C2.25 20.418 3.582 21.75 6 21.75H18C20.418 21.75 21.75 20.418 21.75 18V10C21.75 7.845 20.692 6.553 18.75 6.297ZM20.25 15.75H16.5C15.535 15.75 14.75 14.965 14.75 14C14.75 13.035 15.535 12.25 16.5 12.25H20.25V15.75ZM5 3.75H15C16.577 3.75 17.25 4.423 17.25 6V6.25H5C4.311 6.25 3.75 5.689 3.75 5C3.75 4.311 4.311 3.75 5 3.75ZM18 20.25H6C4.423 20.25 3.75 19.577 3.75 18V7.44897C4.125 7.64097 4.55 7.75 5 7.75H18C19.577 7.75 20.25 8.423 20.25 10V10.75H16.5C14.708 10.75 13.25 12.208 13.25 14C13.25 15.792 14.708 17.25 16.5 17.25H20.25V18C20.25 19.577 19.577 20.25 18 20.25ZM17.01 13H17.02C17.573 13 18.02 13.448 18.02 14C18.02 14.552 17.573 15 17.02 15C16.468 15 16.015 14.552 16.015 14C16.015 13.448 16.458 13 17.01 13Z" fill="#25314C" />
                                </svg>
                                <input onChange={(e) => setInput(e.target.value)} type="number" className='outline-none font-bold' placeholder={t('Enter Amount')} />
                            </div>
                        </div>
                    </div>}

                    <div className="">
                        <h1 className='font-[500] text-[17px] text-gray-500'>{t("Select Payment Methode")}</h1>
                        <div className="h-[400px] scroll-container">
                            {loading
                                ? <div className="h-full w-full flex items-center justify-center">
                                    <div className="loader2"></div>
                                </div>
                                : paymentlist.map((item, index) => {
                                    const isSelect = selectpayment === item.id;
                                    const ShowPayment = Index === 0 ? item.id !== "16" : true;
                                    if (ShowPayment) {
                                        return <div key={index} onClick={() => { setSelectPayment(item.id); setAttributes(item.attributes) }} className={`border-[2px] duration-[0.5s] ${isSelect && "border-[#682afb]"} rounded-[10px] px-[10px] py-[8px] mt-[8px] cursor-pointer`}>
                                            <div className="flex items-center justify-between gap-[10px]">
                                                <div className="flex items-center gap-[10px]">
                                                    <img src={ImgBasUrl + item.img} className='w-[60px] h-[60px] border-[2px] rounded-[10px]' alt="img" />
                                                    <div className="">
                                                        <h1 className='font-[500] text-[17px]'>{item.title}</h1>
                                                        <p className='text-[15px] text-gray-600 font-[500] leading-[18px]'>{item.subtitle}</p>
                                                    </div>
                                                </div>
                                                <div className="w-[30px]">
                                                    <div className={`w-[18px] h-[18px] border-[2px] rounded-full p-[2px] duration-[0.5s] ${isSelect && "border-[#682afb]"}`}>
                                                        <div className={`w-full h-full rounded-full duration-[0.5s] ${isSelect && "bg-[#682afb]"}`}></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                })}
                        </div>
                        <div className="mt-[10px]">
                            <button onClick={HandleContinue} className='button rounded-[10px]'>
                                {paymentloading
                                    ? <span className="loader mx-auto"></span>
                                    : <span>{t("Continue")}</span>}
                            </button>
                        </div>
                    </div>

                </div>
            </div>

            {(selectpayment === "1" && isbutton) && <Razorpay Amount={input || Amount} attributes={attributes} />}
            {(selectpayment === "3" && isbutton) && <div onClick={() => { setSelectPayment(""); setIsButton(false) }} id="BlockSection" className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="w-[20%]  max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
                    <div className="flex flex-col justify-center items-center text-center">
                        <Paypal Amount={input || Amount} attributes={attributes} />
                    </div>
                </div>
            </div>}
            {(selectpayment === "4" && isbutton) && <div onClick={() => { setSelectPayment(""); setIsButton(false) }} id="BlockSection" className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="w-[20%]  max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
                    <div className="flex flex-col justify-center items-center text-center">
                        <Stripe Amount={input || Amount} />
                    </div>
                </div>
            </div>}
            {(selectpayment === "6" && isbutton) && <PayStack Amount={input || Amount} attributes={attributes} />}
            {(selectpayment === "7" && isbutton) && <FlutterWave Amount={input || Amount} attributes={attributes} />}
            {(selectpayment === "8" && isbutton) && <PaytmPayment Amount={input || Amount} />}
            {(selectpayment === "11" && isbutton) && <MercadoPago Amount={input || Amount} />}
            {(selectpayment === "12" && isbutton) && <PayFast Amount={input || Amount} attributes={attributes} />}
            {(selectpayment === "13" && isbutton) && <Midtrans Amount={input || Amount} />}
            {(selectpayment === "15" && isbutton) && <KhaltiPayment Amount={input || Amount} />}
        </div>
    )
}

export default Payment
/* jshint ignore:end */